function adjustBodyPaddingForStickyCart() {
  const stickyCart = document.querySelector('.sticky_cart_mobile');
  if (stickyCart && window.matchMedia('(max-width: 749px)').matches) {
    const height = stickyCart.offsetHeight;
    document.body.style.paddingBottom = `${height}px`;
  } else {
    document.body.style.paddingBottom = '';
  }
}

window.addEventListener('load', () => {
  adjustBodyPaddingForStickyCart();
  syncStickyAddToCartButton();
  syncPdpNotifyFromVariant(getSelectedPdpVariant());
  normalizePdpNotifyLabel();
  dedupePdpNotifyButtons();
  [100, 300, 600, 1000, 1500, 2500, 4000].forEach((delay) => {
    setTimeout(() => {
      syncStickyAddToCartButton();
      syncPdpNotifyFromVariant(getSelectedPdpVariant());
      normalizePdpNotifyLabel();
      dedupePdpNotifyButtons();
    }, delay);
  });
});
window.addEventListener('resize', () => {
  syncStickyAddToCartButton();
  adjustBodyPaddingForStickyCart();
});

const stickyCartMobileMediaQuery = window.matchMedia('(max-width: 749px)');

const pdpSyncVariantUnset = Symbol('pdpSyncVariantUnset');
let pdpButtonSyncScheduled = false;
let pdpSyncVariantArg = pdpSyncVariantUnset;

function schedulePdpButtonSync(variant) {
  if (arguments.length > 0) {
    pdpSyncVariantArg = variant;
  }

  if (pdpButtonSyncScheduled) return;
  pdpButtonSyncScheduled = true;

  requestAnimationFrame(() => {
    pdpButtonSyncScheduled = false;
    const resolvedVariant =
      pdpSyncVariantArg !== pdpSyncVariantUnset ? pdpSyncVariantArg : getSelectedPdpVariant();
    pdpSyncVariantArg = pdpSyncVariantUnset;

    syncStickyAddToCartButton();
    syncPdpNotifyFromVariant(resolvedVariant);
    dedupePdpNotifyButtons();
  });
}

function getSelectedPdpVariant() {
  const selectedVariantNode = document.querySelector(
    '.main_product_section variant-selects [data-selected-variant]'
  );
  if (!selectedVariantNode?.innerHTML) return null;

  try {
    return JSON.parse(selectedVariantNode.innerHTML);
  } catch {
    return null;
  }
}

function syncRestockVariantInput(variantId) {
  window._ReStockConfig = window._ReStockConfig || window._RestockConfig || {};
  window._RestockConfig = window._ReStockConfig;
  window._ReStockConfig.developer_mode_variant_listener = true;

  let restockInput = document.getElementById('restock-variant-change');

  if (!restockInput) {
    restockInput = document.createElement('input');
    restockInput.type = 'hidden';
    restockInput.id = 'restock-variant-change';
    document.body.appendChild(restockInput);
  }

  if (variantId == null || variantId === '') return;

  const nextValue = String(variantId);
  if (restockInput.value === nextValue) return;

  restockInput.value = nextValue;
  restockInput.dispatchEvent(new Event('change', { bubbles: true }));
}

function getMainProductSubmitButton() {
  const formButtons = getMainProductFormButtons();
  return formButtons?.querySelector('.product-form__submit') || null;
}

function shouldShowPdpNotify(variant) {
  const submitBtn = getMainProductSubmitButton();
  const submitHidden = Boolean(submitBtn?.classList.contains('hidden'));

  if (variant && variant.available === false) {
    return true;
  }

  if (variant && variant.available === true && !submitHidden) {
    return false;
  }

  return Boolean(
    submitHidden &&
      (submitBtn?.hasAttribute('disabled') || submitBtn?.getAttribute('aria-disabled') === 'true')
  );
}

function syncPdpComingSoonTagVisibility(showNotify) {
  document
    .querySelectorAll('.main_product_section [data-pdp-coming-soon-tag], .sticky_cart_mobile [data-pdp-coming-soon-tag]')
    .forEach((el) => {
      const metafieldLabel = el.dataset.productTagMetafield || '';
      const comingSoonLabel =
        el.dataset.comingSoonTagLabel || window.variantStrings?.notifyMe || '';

      if (showNotify) {
        el.textContent = comingSoonLabel;
        el.classList.remove('hidden');
        el.removeAttribute('hidden');
        return;
      }

      if (metafieldLabel) {
        el.textContent = metafieldLabel;
        el.classList.remove('hidden');
        el.removeAttribute('hidden');
        return;
      }

      el.classList.add('hidden');
      el.toggleAttribute('hidden', true);
    });
}

function getPdpNotifyNodes() {
  return document.querySelectorAll(
    '.main_product_section .product-form__buttons .nm-portal, .main_product_section .product-form__buttons .cqa-notify-slot, .main_product_section .restock-alerts-notify-button.PRODUCT_PAGE-notify-button, .sticky_add_to_cart_wrapper .cqa-notify-slot, .sticky_add_to_cart_wrapper .restock-alerts-notify-button'
  );
}

let isNormalizingPdpNotify = false;

function normalizePdpNotifyLabel() {
  if (isNormalizingPdpNotify) return;
  const notifySlot = document.querySelector('.main_product_section .cqa-notify-slot');
  const rawLabel = notifySlot?.dataset?.notifyLabel || window.variantStrings?.notifyMe;
  const label = rawLabel ? rawLabel.toUpperCase() : rawLabel;
  if (!label) return;

  const buttons = document.querySelectorAll(
    '.main_product_section .restock-alerts-notify-button.PRODUCT_PAGE-notify-button, .sticky_add_to_cart_wrapper .restock-alerts-notify-button.PRODUCT_PAGE-notify-button, .restock-alerts-notify-button.PRODUCT_PAGE-notify-button, .PRODUCT_PAGE-notify-button, .main_product_section .restock-alerts-notify-button, .sticky_add_to_cart_wrapper .restock-alerts-notify-button, .main_product_section .cqa-notify-anchor, .sticky_add_to_cart_wrapper .cqa-notify-anchor'
  );

  if (!buttons.length) return;

  isNormalizingPdpNotify = true;
  try {
    buttons.forEach((button) => {
      if (typeof window.applyComingSoonButtonLabel === 'function') {
        window.applyComingSoonButtonLabel(button, label);
        return;
      }

      const labelEl = button.querySelector('.cqa-notify-label');
      if (labelEl) {
        if (labelEl.textContent !== label) {
          labelEl.textContent = label;
        }
        return;
      }

      if (button.textContent.trim() !== label) {
        button.textContent = label;
      }
    });
  } finally {
    isNormalizingPdpNotify = false;
  }
}

function dedupePdpNotifyButtons() {
  const notifySlot = document.querySelector('.main_product_section .product-form__buttons .cqa-notify-slot');
  if (!notifySlot) return;

  const appPortals = Array.from(
    document.querySelectorAll('.main_product_section .product-form__buttons > .nm-portal, .main_product_section .product-form__buttons > .restock-alerts-notify-button')
  );

  appPortals.forEach((node) => {
    if (!notifySlot.contains(node)) {
      notifySlot.appendChild(node);
      const placeholder = notifySlot.querySelector('.cqa-notify-anchor:not(.restock-alerts-notify-button)');
      if (placeholder && node !== placeholder) {
        placeholder.remove();
      }
    }
  });

  normalizePdpNotifyLabel();
}

function setPdpNotifyVisibility(showNotify) {
  if (!getMainProductFormButtons() && !document.querySelector('.restock-alerts-notify-button.PRODUCT_PAGE-notify-button') && !document.querySelector('.cqa-notify-slot')) {
    return;
  }

  getPdpNotifyNodes().forEach((node) => {
    const isNotifyButton = node.classList.contains('restock-alerts-notify-button') || node.classList.contains('cqa-notify-anchor');

    if (showNotify) {
      node.removeAttribute('hidden');
      if (isNotifyButton) {
        node.style.setProperty('display', 'flex', 'important');
        node.style.setProperty('justify-content', 'center', 'important');
        node.style.setProperty('align-items', 'center', 'important');
      } else {
        node.style.setProperty('display', 'block', 'important');
      }
    } else {
      node.setAttribute('hidden', '');
      node.style.setProperty('display', 'none', 'important');
    }
  });

  if (showNotify) {
    normalizePdpNotifyLabel();
  }
}

let pdpNotifyResyncTimer = null;

function queuePdpNotifyResync() {
  clearTimeout(pdpNotifyResyncTimer);
  pdpNotifyResyncTimer = setTimeout(() => {
    syncPdpNotifyFromVariant(getSelectedPdpVariant());
  }, 250);
}

function syncMainPaymentButtonVisibility(isUnavailable) {
  const paymentEl = getDynamicCheckoutElement();
  if (!paymentEl) return;

  const shouldHide = Boolean(isUnavailable);
  paymentEl.classList.toggle('hidden', shouldHide);
  if (shouldHide !== paymentEl.hasAttribute('hidden')) {
    paymentEl.toggleAttribute('hidden', shouldHide);
  }
}

function syncPdpNotifyFromVariant(variant) {
  if (variant?.id) {
    syncRestockVariantInput(variant.id);
    document.querySelectorAll(
      '.main_product_section .cqa-notify-anchor, .sticky_add_to_cart_wrapper .cqa-notify-anchor, .main_product_section .restock-alerts-notify-button, .sticky_add_to_cart_wrapper .restock-alerts-notify-button'
    ).forEach((btn) => {
      btn.setAttribute('data-variant-id', String(variant.id));
    });
  }

  const showNotify = shouldShowPdpNotify(variant);
  setPdpNotifyVisibility(showNotify);
  syncMainPaymentButtonVisibility(showNotify);
  syncPdpComingSoonTagVisibility(showNotify);
  syncStickyAddToCartButton();

  if (showNotify) {
    queuePdpNotifyResync();
  }
}

window.eseoeseSyncPdpNotify = schedulePdpButtonSync;

function getMainProductFormButtons() {
  return document.querySelector('.main_product_section .product-form__buttons');
}

function getDynamicCheckoutElement() {
  const formButtons = getMainProductFormButtons();
  if (!formButtons) return null;
  return formButtons.querySelector('.shopify-payment-button, shopify-accelerated-checkout');
}

function syncStickyPaymentButton(isUnavailable) {
  const slot = document.querySelector('.sticky_payment_button_slot');
  const formButtons = getMainProductFormButtons();
  const paymentEl = getDynamicCheckoutElement();
  if (!slot || !formButtons || !paymentEl) return;

  if (stickyCartMobileMediaQuery.matches) {
    if (paymentEl.parentElement !== slot) {
      slot.appendChild(paymentEl);
    }
    slot.classList.toggle('hidden', isUnavailable);
  } else if (paymentEl.parentElement === slot) {
    const submitBtn = formButtons.querySelector('.product-form__submit');
    if (submitBtn) {
      submitBtn.insertAdjacentElement('afterend', paymentEl);
    } else {
      formButtons.appendChild(paymentEl);
    }
    slot.classList.remove('hidden');
  }
}

function syncStickyAddToCartButton() {
  const stickyBtn = document.querySelector('.sticky_add_to_cart_btn');
  const stickySlot = document.querySelector('.sticky_add_to_cart_wrapper .cqa-notify-slot');
  const stickyNotifyBtn = document.querySelector('.sticky_add_to_cart_wrapper .restock-alerts-notify-button, .sticky_add_to_cart_wrapper .cqa-notify-anchor');
  if (!stickyBtn) return;

  const targetId = stickyBtn.getAttribute('data-submit-id');
  const mainBtn = targetId ? document.getElementById(targetId) : null;
  const isUnavailable = mainBtn
    ? mainBtn.hasAttribute('disabled') || mainBtn.classList.contains('hidden')
    : stickyBtn.hasAttribute('disabled');

  stickyBtn.toggleAttribute('disabled', isUnavailable);
  stickyBtn.classList.toggle('hidden', isUnavailable);

  if (stickySlot) {
    stickySlot.classList.toggle('hidden', !isUnavailable);
    if (isUnavailable) {
      stickySlot.removeAttribute('hidden');
      stickySlot.style.setProperty('display', 'flex', 'important');
    } else {
      stickySlot.setAttribute('hidden', '');
      stickySlot.style.setProperty('display', 'none', 'important');
    }
  }

  if (stickyNotifyBtn) {
    stickyNotifyBtn.classList.toggle('hidden', !isUnavailable);
    if (isUnavailable) {
      stickyNotifyBtn.removeAttribute('hidden');
      stickyNotifyBtn.style.setProperty('display', 'flex', 'important');
      stickyNotifyBtn.style.setProperty('justify-content', 'center', 'important');
      stickyNotifyBtn.style.setProperty('align-items', 'center', 'important');
    } else {
      stickyNotifyBtn.setAttribute('hidden', '');
      stickyNotifyBtn.style.setProperty('display', 'none', 'important');
    }
  }

  const mainText = mainBtn ? mainBtn.querySelector('span') : null;
  const stickyText = stickyBtn.querySelector('span');
  if (mainText && stickyText && !isUnavailable) {
    stickyText.textContent = mainText.textContent;
  }

  syncStickyPaymentButton(isUnavailable);
  adjustBodyPaddingForStickyCart();
}

document.addEventListener('DOMContentLoaded', () => {
  adjustBodyPaddingForStickyCart();
  syncStickyAddToCartButton();
  syncPdpNotifyFromVariant(getSelectedPdpVariant());
  normalizePdpNotifyLabel();
  dedupePdpNotifyButtons();

  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      schedulePdpButtonSync(event?.data?.variant ?? null);
    });
  }

  const productForm = document.querySelector('.main_product_section product-form');
  const observeTarget = productForm ? productForm.parentElement : null;
  if (observeTarget) {
    const notifyObserver = new MutationObserver(() => {
      schedulePdpButtonSync(undefined);
    });
    notifyObserver.observe(observeTarget, { childList: true, subtree: true });
  }

  const formButtons = getMainProductFormButtons();
  if (formButtons) {
    const paymentObserver = new MutationObserver(() => {
      schedulePdpButtonSync(undefined);
    });
    paymentObserver.observe(formButtons, { childList: true, subtree: true });
  }

  const notifyBodyObserver = new MutationObserver((mutations) => {
    if (isNormalizingPdpNotify) return;
    let shouldNormalize = false;
    for (const mutation of mutations) {
      const target = mutation.target;
      if (
        target?.classList?.contains('restock-alerts-notify-button') ||
        target?.classList?.contains('PRODUCT_PAGE-notify-button') ||
        target?.closest?.('.restock-alerts-notify-button, .PRODUCT_PAGE-notify-button, .nm-portal')
      ) {
        shouldNormalize = true;
        break;
      }
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (
            node.matches?.('.restock-alerts-notify-button, .PRODUCT_PAGE-notify-button, .nm-portal') ||
            node.querySelector?.('.restock-alerts-notify-button, .PRODUCT_PAGE-notify-button')
          ) {
            shouldNormalize = true;
            break;
          }
        }
      }
      if (shouldNormalize) break;
    }
    if (shouldNormalize) {
      dedupePdpNotifyButtons();
      normalizePdpNotifyLabel();
    }
  });

  notifyBodyObserver.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  if (window.Shopify?.PaymentButton?.init) {
    const originalInit = window.Shopify.PaymentButton.init.bind(window.Shopify.PaymentButton);
    window.Shopify.PaymentButton.init = function (...args) {
      const result = originalInit(...args);
      syncStickyAddToCartButton();
      return result;
    };
  }

function getMainPdpNotifyButton() {
  const formButtons = document.querySelector('.main_product_section .product-form__buttons');
  if (formButtons) {
    const portalBtn = formButtons.querySelector('.nm-portal .restock-alerts-notify-button');
    if (portalBtn) return portalBtn;

    const slotBtn = formButtons.querySelector(
      '.cqa-notify-slot .restock-alerts-notify-button, .cqa-notify-slot .cqa-notify-anchor, .cqa-notify-slot [id^="restock-"]'
    );
    if (slotBtn) return slotBtn;

    const anyFormBtn = formButtons.querySelector('.restock-alerts-notify-button, .cqa-notify-anchor, [id^="restock-"]');
    if (anyFormBtn) return anyFormBtn;
  }

  const anyMainProductBtn = document.querySelector('.main_product_section [id^="restock-"]:not([id*="sticky"])');
  if (anyMainProductBtn) return anyMainProductBtn;

  return document.querySelector('[id^="restock-"]:not([id*="sticky"]):not(.sticky_notify_btn)');
}

  let isForwardingRestockClick = false;

  document.addEventListener(
    'click',
    (e) => {
      if (isForwardingRestockClick) return;

      const notifyBtn = e.target.closest(
        '.main_product_section .cqa-notify-anchor, .sticky_add_to_cart_wrapper .cqa-notify-anchor, .main_product_section .restock-alerts-notify-button, .sticky_add_to_cart_wrapper .restock-alerts-notify-button, custom-quick-add-overlay .cqa-notify-anchor, custom-quick-add-overlay .restock-alerts-notify-button'
      );
      if (!notifyBtn) return;

      const overlay = notifyBtn.closest('custom-quick-add-overlay');
      let variantId = notifyBtn.getAttribute('data-variant-id');

      if (!variantId && overlay) {
        const variantInput = overlay.querySelector('.cqa-variant-id');
        variantId = variantInput?.value;
      }

      if (!variantId) {
        const variant = getSelectedPdpVariant();
        variantId = variant?.id;
      }

      if (variantId) {
        syncRestockVariantInput(variantId);
      }

      if (overlay) {
        overlay.classList.add('hidden');
        document.body.classList.remove('card_product_pop_up', 'o-hidden');
      }

      const mainBtn = getMainPdpNotifyButton();
      if (mainBtn && mainBtn !== notifyBtn) {
        e.preventDefault();
        e.stopPropagation();
        isForwardingRestockClick = true;
        try {
          mainBtn.click();
        } finally {
          setTimeout(() => {
            isForwardingRestockClick = false;
          }, 150);
        }
        return;
      }

      const portalBtn =
        mainBtn?.querySelector?.('.restock-alerts-notify-button') ||
        mainBtn?.closest?.('.cqa-notify-slot')?.querySelector?.('.nm-portal .restock-alerts-notify-button');
      if (portalBtn && portalBtn !== notifyBtn) {
        e.preventDefault();
        e.stopPropagation();
        isForwardingRestockClick = true;
        try {
          portalBtn.click();
        } finally {
          setTimeout(() => {
            isForwardingRestockClick = false;
          }, 150);
        }
        return;
      }
    },
    true
  );

  const stickyCartBtns = document.querySelectorAll('.sticky_add_to_cart_btn');
  
  stickyCartBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const targetId = btn.getAttribute('data-submit-id');
      const mainBtn = document.getElementById(targetId);
      
      if (window.innerWidth <= 749) {
        // Find the native popup rendered via Liquid by its ID (since it may have been moved to the body)
        const sectionId = targetId.replace('ProductSubmitButton-', '');
        const overlay = document.getElementById('ProductStickyPopup-' + sectionId);
        
        if (overlay) {
          // Close any other open overlays
          document.querySelectorAll('custom-quick-add-overlay:not(.hidden)').forEach(openOverlay => {
            if (openOverlay !== overlay) {
              openOverlay.classList.add('hidden');
            }
          });
          
          // Move to body to prevent transform nesting issues
          if (overlay.parentNode !== document.body) {
            overlay.originalParent = overlay.parentNode;
            overlay.originalNextSibling = overlay.nextSibling;
            document.body.appendChild(overlay);
          }
          
          // Show the drawer
          overlay.classList.remove('hidden');
          document.body.classList.add('card_product_pop_up', 'o-hidden');
          if (typeof overlay.updateVariant === 'function') {
            overlay.updateVariant();
          }
          return; // Stop here, do not click the main button yet!
        }
      }

      // Default behavior (No variants or Desktop)
      if (mainBtn) {
          mainBtn.click();
      }
    });
  });
});
